import React from 'react';
import _ from 'lodash';

import {
  useAdministratorInvitesWidgetQuery,
  UserStatusName,
  useSaveUserMutation
} from 'generated/graphql';

import { DateTime } from 'luxon';



export interface IInvite {
  id: string;
  email: string;
  sentTimestamp: DateTime | null;
  isClaimed: boolean;
}

export interface IData {
  invites: IInvite[];
}

export function useQuery() {
  const tuple = useAdministratorInvitesWidgetQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        invites: _.map(tuple.data?.invites.nodes, (invite): IInvite => ({
          id: invite.id,
          email: invite.recipientEmail,
          sentTimestamp: invite.sentTimestamp ? DateTime.fromISO(invite.sentTimestamp) : null,
          isClaimed: !_.isNil(invite.claimant)
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveUser() {
  const [fnMutate, tuple] = useSaveUserMutation({
    refetchQueries: [
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (id: string, status: UserStatusName) => {
      fnMutate({
        variables: {
          input: {
            id,
            status
          }
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
